var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"80%"}},[_c('v-progress-circular',{attrs:{"size":100,"width":5,"color":"rgb(0, 48, 143)","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }